import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Toolbar, TextField, Stack, Typography } from "@mui/material";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./Datagrid.css";
const Datagrid = ({
	data,
	columns,
	onSelect,
	customButtons,
	onPageChange,
	rowIdField,
	sortBy,
	pageSize = 10, // Default page size
	showSearchBar = true, // Control search bar visibility
	checkboxSelection = false, // Control checkbox visibility
	rowClick = false,
	onRowClick,
	noDataText = "No Rows",
	pageSizeOptions = [pageSize],
}) => {
	const [searchText, setSearchText] = useState("");
	const [filteredData, setFilteredData] = useState(data);
	const [matchedRowIds, setMatchedRowIds] = useState([]);
	const [sortModel, setSortModel] = useState(sortBy || []);

	const handleSelectionChange = (newSelection) => {
		console.log(newSelection);
		if (onSelect) {
			onSelect(newSelection);
		}
	};

	useEffect(() => {
		setFilteredData(data);
	}, [data]);

	const handleSearchChange = (e) => {
		const query = e.target.value.toLowerCase();
		setSearchText(query);

		// Filter rows based on search query
		const filteredRows = data.filter((row) => {
			return columns.some((column) => {
				const cellValue = row[column.field]?.toString()?.toLowerCase();
				return cellValue?.includes(query);
			});
		});
		setFilteredData(filteredRows);
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				height: "fit-content",
				width: "100%",
				marginBottom: "30px",
			}}>
			{/* Flexbox layout for search and buttons */}
			{showSearchBar && (
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						marginBottom: "5px",
					}}>
					<TextField
						variant="outlined"
						size="small"
						value={searchText}
						onChange={handleSearchChange}
						placeholder="Search..."
						style={{ minWidth: "20%" }}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<SearchIcon />
								</InputAdornment>
							),
						}}
					/>

					{/* Custom Buttons */}
					<Toolbar style={{ display: "flex", gap: "8px", margin: 0, padding: 0 }}>
						{customButtons &&
							customButtons.map((button, index) => (
								<Button
									key={index}
									startIcon={button?.icon}
									variant="contained"
									color="primary"
									onClick={button.onClick}>
									{button.label}{" "}
									{button?.upload && (
										<input
											type="file"
											hidden
											onChange={button?.handleFileChange}
											accept={button?.acceptedFile} // Adjust file types as needed
										/>
									)}
								</Button>
							))}
					</Toolbar>
				</div>
			)}

			{/* DataGrid */}
			<div style={{ flexGrow: 1, width: "100%", height: "inherit" }}>
				<DataGrid
					rows={filteredData}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize:
									filteredData && filteredData.length > 0
										? Math.max(5, Math.min(pageSize, filteredData.length))
										: 10,
							},
						},
					}}
					sortModel={sortModel}
					onSortModelChange={(newModel) => setSortModel(newModel)}
					{...(rowClick && { onRowClick })}
					components={{
						NoRowsOverlay: () => (
							<Stack height="100%" alignItems="center" justifyContent="center">
								{noDataText}
							</Stack>
						),
						NoResultsOverlay: () => (
							<Stack height="100%" alignItems="center" justifyContent="center">
								Local filter returns no result
							</Stack>
						),
					}}
					pageSizeOptions={[5, 10, 50, 100]}
					onRowSelectionModelChange={handleSelectionChange}
					onPageChange={onPageChange}
					disableSelectionOnClick
					checkboxSelection={checkboxSelection} // Enable/Disable checkbox based on prop
					getRowId={(row) => row[rowIdField]}
					sx={{
						".MuiTablePagination-selectLabel": {
							marginBottom: 0,
						},
						".MuiTablePagination-displayedRows": {
							marginBottom: 0,
						},
					}}
					keepNonExistentRowsSelected
				/>
			</div>
		</div>
	);
};

export default Datagrid;
